// Copyright (c) 2022 by Move Closer

import { PropType } from '@vue/composition-api'
import { RawLocation } from 'vue-router'

import {
  abstractPaginationProps,
  usePagination as abstractHook
} from '../../abstract/components/Pagination/Pagination.hooks'
import { ComponentObjectPropsOptions, Emit } from '../../vue-api'
import { PAGINATION_NEXT, PAGINATION_PREV } from '../../abstract/components/Pagination/Pagination.contracts'

import { PaginationProps, PaginationTarget, UsePaginationProvides } from './Pagination.contracts'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl> (original)
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (edited)
 */
export const paginationProps: ComponentObjectPropsOptions<PaginationProps> = {
  ...abstractPaginationProps,

  link: {
    type: Object as PropType<PaginationTarget | undefined>,
    required: false
  }
}

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (original)
 */
export const usePagination = (props: PaginationProps, emit: Emit): UsePaginationProvides => {
  const resolveTarget = (page: number): { target: RawLocation } => {
    if (!props.link) {
      return { target: '#' }
    }

    let target: RawLocation
    if (typeof props.link.target === 'string') {
      target = `${props.link.target}${props.link.target.indexOf('?') > 0 ? '&' : '?'}${props.link.param}=${page}`
    } else {
      target = { ...props.link.target, query: { ...props.link.target.query, [props.link.param]: String(page) } }
    }

    return { target }
  }

  return {
    ...abstractHook(props, emit),
    PAGINATION_NEXT,
    PAGINATION_PREV,
    resolveTarget
  }
}
